import { PaymentValueTypes } from '@specs/specs'
import { getCookie, setCookie } from 'cookies-next'
import { toy } from '@prisma/client'
import { cartFeature } from '@specs/features'

interface IFigure {
    toyId: toy['id']
    instanceId: number
    digitalDropId: number | null
    price: number
    storeItemId: number
    currency: PaymentValueTypes
    status?: 'available' | 'store.item.not.available' | 'store.item.ended'
}

export interface ICartItemToys {
    toyId: toy['id']
    figures: IFigure[]
}

export const addToysToCart = (cartList: ICartItemToys[]) => {
    setCookie('cartItems', cartList, { maxAge: 60 * 60 * 24 * 365 })
    document.dispatchEvent(new CustomEvent('cart_event', { detail: cartList as ICartItemToys[] }))
}

export const getToysInCartFromCookies = () => JSON.parse((getCookie(cartFeature.COOKIES.cartItems) as string | undefined) ?? '[]') as ICartItemToys[]
export const getToysStoreItemsInCartFromCookies = () => (JSON.parse((getCookie(cartFeature.COOKIES.cartItems) as string | undefined) ?? '[]') as ICartItemToys[]).flatMap(({ figures }) => figures)
export const checkToyIsInCart = (toyId: toy['id']) => !!getToysInCartFromCookies().find((el) => el.toyId === toyId)
export const checkToyInstanceIdIsInCart = (toyId: toy['id'], instanceId: number) => !!getToysStoreItemsInCartFromCookies().find((el) => el.instanceId === instanceId && el.toyId === toyId)
